module.exports = "/_next/static/images/dish-9d3c342441c16370a55c346a177bb092.png";